// Accessibility fix: Add missing labels to all inputs and textareas in .contact-section #contactForm
// Adds a visually hidden label if missing


function ensureContactFormAccessibility() {
  var form = document.querySelector('.contact-section #contactForm');
  if (!form) return;
  var fields = form.querySelectorAll('input, textarea');
  fields.forEach(function(field, idx) {
    // Skip buttons
    if (field.type === 'submit' || field.type === 'button' || field.type === 'hidden') return;
    // Ensure ID
    if (!field.id) {
      field.id = (field.name || 'contact-field-' + idx) + '-' + idx;
    }
    var id = field.id;
    // Check for existing label
    var hasLabel = !!form.querySelector('label[for="' + id + '"]');
    if (!hasLabel) {
      var label = document.createElement('label');
      label.setAttribute('for', id);
      label.className = 'sr-only';
      label.textContent = field.placeholder || field.name || 'Form field';
      field.parentNode.insertBefore(label, field);
    }
  });
}

document.addEventListener("DOMContentLoaded", ensureContactFormAccessibility);
// If your form is loaded via AJAX, call ensureContactFormAccessibility() after the form is rendered.
